import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=20d72d08&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=20d72d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d72d08",
  null
  
)

export default component.exports